const useMetaTitle = (value: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  document.title = value;
};

const useMetaDescription = (value: string) => {
  const metatag = document.querySelector('meta[name="description"]');

  if (metatag) {
    metatag.setAttribute('content', value);
  }
};

export { useMetaTitle, useMetaDescription };
